import {PlusIcon} from "@heroicons/react/20/solid";

type Props = {
    title: string;
    description: string;
    label: string;
    onClick: () => void;
};

export default function HeaderTextButton({
                                             title,
                                             description,
                                             label,
                                             onClick,
                                         }: Props) {
    return (
        <div className="sm:flex sm:items-center">
            <div className="sm:flex-auto">
                <h1 className="text-xl font-semibold text-blue-900">{title}</h1>
                <p className="mt-2 text-md text-gray-700">{description}</p>
            </div>
            <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                <button
                    type="button"
                    onClick={onClick}
                    className="inline-flex items-center rounded-md bg-blue-900 px-3 py-2 text-md font-semibold text-white shadow-xs hover:bg-blue-800 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800"
                >
                    <PlusIcon aria-hidden="true" className="mr-1.5 -ml-0.5 size-5"/>
                    {label}
                </button>
            </div>
        </div>
    );
}
